// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-box-three:hover .course-three-content[data-v-1f5b4964]{background-color:green;transition:.7s}.course-box-three-echoflix:hover .course-three-content-echoflix[data-v-1f5b4964]{background-color:#000;transition:.7s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
